(function() {
    var $venueLoc = $("#venueLocation");
    var venueAddress = $venueLoc.text();
    var venueName = $("#venueLink").text();
    var text = venueName + " " + venueAddress;
    var escapedTerm = EscapeGoogleTerm(text);
    var term = escapedTerm.replace(/\s/g, "+");
    var href = "https://www.google.com/maps/search/" + term;

    $venueLoc.attr("href", href);
})();

$(document).ready(function() {
    setupImage();
    initResizeMap();
    initResizeFpContainer();
    initEventsTable();

    hljs.initHighlightingOnLoad();
});

function setupImage() {
    $("#fp")
        .on("load", function() { $("#spinner-overlay").hide(); })
        .on("error", function() { $("#spinner-overlay").hide(); })
        .attr("src", $("#fp").data("src"));
}

function initResizeMap() {
    resizeMap();
    $(window).on("resize", resizeMap);
}

function resizeMap() {
    var $frame = $("#googleMapsFrame");
    var $container = $frame.parent();
    var width = $container.width();
    $frame.width(width);
    $frame.height(width / 16 * 7);
}

function initResizeFpContainer() {
    resizeFpContainer();
    $(window).on("resize", resizeFpContainer);
}

function resizeFpContainer() {
    var $cont = $("#fpContainer");
    var width = $cont.width();
    var height = width / 1.776;
    $cont.height(height);
}

function initEventsTable() {
    $(".event-row").on("click",
        function() {
            var $link = $(this).find(".event-link");
            var href = $link.attr("href");
            window.location.href = href;
        });
}